module.exports = __webpack_public_path__ + "static/media/07-lab1.b50eb706.png";